import { render } from "./taxrates.vue?vue&type=template&id=529fba1e&scoped=true"
import script from "./taxrates.vue?vue&type=script&lang=js"
export * from "./taxrates.vue?vue&type=script&lang=js"

import "./taxrates.vue?vue&type=style&index=0&id=529fba1e&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-529fba1e"]])

export default __exports__